import { useState, useCallback, useEffect } from 'react';

export const useDropdown = () => {
  const [isOpened, setIsOpened] = useState(false);
  const open = useCallback(() => setIsOpened(true), []);
  const close = useCallback(() => setIsOpened(false), []);

  useEffect(() => {
    if (!isOpened) return;

    document.addEventListener('click', close);
    return () => {
      document.removeEventListener('click', close);
    };
  }, [isOpened, close]);

  return {
    open,
    close,
    isOpened,
  };
};
